// Online store orders and customers (flag `store`).
export const ordersEn = {
  'orders.subtitle': 'Orders from the online store. Payments and shipping on this demo are made up.',
  'orders.customersSubtitle': 'People with an account on the online store. They cannot sign in to this CMS.',
  'orders.status.pending_payment': 'Waiting for payment',
  'orders.status.paid': 'Paid',
  'orders.status.packed': 'Packed',
  'orders.status.shipped': 'Shipped',
  'orders.status.delivered': 'Delivered',
  'orders.status.cancelled': 'Cancelled',
  'orders.status.expired': 'Expired',
  'orders.status.refunded': 'Refunded',
  'orders.filter.status': 'Status',
  'orders.filter.from': 'From',
  'orders.filter.to': 'To',
  'orders.filter.search': 'Order number, name or email',
  'orders.filter.clear': 'Clear filters',
  'orders.col.order': 'Order',
  'orders.col.customer': 'Customer',
  'orders.col.status': 'Status',
  'orders.col.total': 'Total',
  'orders.col.placed': 'Placed',
  'orders.col.actions': 'Actions',
  'orders.col.email': 'Email',
  'orders.col.orders': 'Orders',
  'orders.col.joined': 'Joined',
  'orders.col.lastLogin': 'Last sign-in',
  'orders.guest': 'Guest',
  'orders.items': '{count} items',
  'orders.item': '1 item',
  'orders.open': 'Open',
  'orders.empty.title': 'No orders yet',
  'orders.empty.body': 'Orders placed on the online store appear here.',
  'orders.customersEmpty.title': 'No customers yet',
  'orders.customersEmpty.body': 'People who create an account on the online store appear here.',
  'orders.prev': '← Previous',
  'orders.next': 'Next →',
  'orders.pageOf': 'Page {page} of {total}',
  'orders.detail.back': 'All orders',
  'orders.detail.items': 'Items',
  'orders.detail.subtotal': 'Subtotal',
  'orders.detail.shipping': 'Shipping',
  'orders.detail.discount': 'Discount ({code})',
  'orders.detail.total': 'Total',
  'orders.detail.customer': 'Customer',
  'orders.detail.address': 'Delivery address',
  'orders.detail.delivery': 'Delivery',
  'orders.detail.payment': 'Payment',
  'orders.detail.paymentDue': 'Payment due by {time}',
  'orders.detail.paidAt': 'Paid {time}',
  'orders.detail.va': 'Demo virtual account {number}',
  'orders.detail.tracking': 'Tracking number',
  'orders.detail.timeline': 'Timeline',
  'orders.detail.anonymised': 'The customer deleted their account: their name, email, phone and street were removed.',
  'orders.detail.guestOrder': 'Guest order (no account)',
  'orders.detail.accountOrder': 'Placed with an account',
  'orders.detail.actions': 'Update the order',
  'orders.detail.markPacked': 'Mark packed',
  'orders.detail.markShipped': 'Mark shipped',
  'orders.detail.markDelivered': 'Mark delivered',
  'orders.detail.cancel': 'Cancel order',
  'orders.detail.refund': 'Mark refunded',
  'orders.detail.noActions': 'Nothing to change: this order is finished.',
  'orders.detail.trackingLabel': 'Tracking number',
  'orders.detail.trackingHint': 'Letters, digits and dashes. On this demo any made-up number will do.',
  'orders.detail.generate': 'Make up a number',
  'orders.detail.note': 'Note for the timeline (optional)',
  'orders.detail.cancelConfirm': 'Cancel order {number}? Its items go back into stock.',
  'orders.detail.refundConfirm': 'Mark order {number} as refunded? This is a mark only: no money moves on this demo.',
  'orders.detail.updated': 'Order updated',
  'orders.customer.delete': 'Delete',
  'orders.customer.deleteConfirm': 'Delete the account of {name}? Their addresses and wishlist are deleted; their orders stay, without name, email, phone or street.',
  'orders.customer.deleted': 'Customer deleted',
  'orders.demoReset.button': 'Reset demo now',
  'orders.demoReset.title': 'Reset the demo now?',
  'orders.demoReset.body': 'This deletes every shop customer, their addresses, wishlists and orders, and the uses of discount codes. Stock, prices and discount codes go back to the demo values. Pages, media, settings and CMS users stay. The demo also resets by itself every night at 03:00 WIB.',
  'orders.demoReset.confirm': 'Reset demo',
  'orders.demoReset.done': 'Demo reset: {orders} orders and {customers} customers deleted',
  'orders.demoReset.last': 'Last reset {time}',
}

export const ordersId: Record<keyof typeof ordersEn, string> = {
  'orders.subtitle': 'Pesanan dari toko online. Pembayaran dan pengiriman di demo ini hanya karangan.',
  'orders.customersSubtitle': 'Orang yang punya akun di toko online. Mereka tidak bisa masuk ke CMS ini.',
  'orders.status.pending_payment': 'Menunggu pembayaran',
  'orders.status.paid': 'Sudah dibayar',
  'orders.status.packed': 'Dikemas',
  'orders.status.shipped': 'Dikirim',
  'orders.status.delivered': 'Sampai',
  'orders.status.cancelled': 'Dibatalkan',
  'orders.status.expired': 'Kedaluwarsa',
  'orders.status.refunded': 'Dana dikembalikan',
  'orders.filter.status': 'Status',
  'orders.filter.from': 'Dari',
  'orders.filter.to': 'Sampai',
  'orders.filter.search': 'Nomor pesanan, nama, atau email',
  'orders.filter.clear': 'Hapus filter',
  'orders.col.order': 'Pesanan',
  'orders.col.customer': 'Pelanggan',
  'orders.col.status': 'Status',
  'orders.col.total': 'Total',
  'orders.col.placed': 'Dipesan',
  'orders.col.actions': 'Aksi',
  'orders.col.email': 'Email',
  'orders.col.orders': 'Pesanan',
  'orders.col.joined': 'Bergabung',
  'orders.col.lastLogin': 'Terakhir masuk',
  'orders.guest': 'Tamu',
  'orders.items': '{count} barang',
  'orders.item': '1 barang',
  'orders.open': 'Buka',
  'orders.empty.title': 'Belum ada pesanan',
  'orders.empty.body': 'Pesanan dari toko online akan muncul di sini.',
  'orders.customersEmpty.title': 'Belum ada pelanggan',
  'orders.customersEmpty.body': 'Orang yang membuat akun di toko online akan muncul di sini.',
  'orders.prev': '← Sebelumnya',
  'orders.next': 'Berikutnya →',
  'orders.pageOf': 'Halaman {page} dari {total}',
  'orders.detail.back': 'Semua pesanan',
  'orders.detail.items': 'Barang',
  'orders.detail.subtotal': 'Subtotal',
  'orders.detail.shipping': 'Ongkir',
  'orders.detail.discount': 'Diskon ({code})',
  'orders.detail.total': 'Total',
  'orders.detail.customer': 'Pelanggan',
  'orders.detail.address': 'Alamat pengiriman',
  'orders.detail.delivery': 'Pengiriman',
  'orders.detail.payment': 'Pembayaran',
  'orders.detail.paymentDue': 'Bayar paling lambat {time}',
  'orders.detail.paidAt': 'Dibayar {time}',
  'orders.detail.va': 'Virtual account demo {number}',
  'orders.detail.tracking': 'Nomor resi',
  'orders.detail.timeline': 'Riwayat',
  'orders.detail.anonymised': 'Pelanggan sudah menghapus akunnya: nama, email, nomor HP, dan alamat jalannya sudah dihapus.',
  'orders.detail.guestOrder': 'Pesanan tamu (tanpa akun)',
  'orders.detail.accountOrder': 'Dipesan dengan akun',
  'orders.detail.actions': 'Perbarui pesanan',
  'orders.detail.markPacked': 'Tandai dikemas',
  'orders.detail.markShipped': 'Tandai dikirim',
  'orders.detail.markDelivered': 'Tandai sampai',
  'orders.detail.cancel': 'Batalkan pesanan',
  'orders.detail.refund': 'Tandai dana dikembalikan',
  'orders.detail.noActions': 'Tidak ada yang perlu diubah: pesanan ini sudah selesai.',
  'orders.detail.trackingLabel': 'Nomor resi',
  'orders.detail.trackingHint': 'Huruf, angka, dan tanda strip. Di demo ini nomor karangan pun boleh.',
  'orders.detail.generate': 'Buat nomor karangan',
  'orders.detail.note': 'Catatan untuk riwayat (opsional)',
  'orders.detail.cancelConfirm': 'Batalkan pesanan {number}? Barangnya kembali ke stok.',
  'orders.detail.refundConfirm': 'Tandai pesanan {number} sebagai dana dikembalikan? Ini cuma tanda: di demo ini tidak ada uang yang berpindah.',
  'orders.detail.updated': 'Pesanan diperbarui',
  'orders.customer.delete': 'Hapus',
  'orders.customer.deleteConfirm': 'Hapus akun {name}? Alamat dan wishlist-nya terhapus; pesanannya tetap ada tanpa nama, email, nomor HP, atau alamat jalan.',
  'orders.customer.deleted': 'Pelanggan dihapus',
  'orders.demoReset.button': 'Reset demo sekarang',
  'orders.demoReset.title': 'Reset demo sekarang?',
  'orders.demoReset.body': 'Semua pelanggan toko, alamat, wishlist, dan pesanannya akan dihapus, begitu juga pemakaian kode diskon. Stok, harga, dan kode diskon kembali ke nilai demo. Halaman, media, pengaturan, dan pengguna CMS tetap ada. Demo ini juga reset sendiri setiap malam pukul 03.00 WIB.',
  'orders.demoReset.confirm': 'Reset demo',
  'orders.demoReset.done': 'Demo direset: {orders} pesanan dan {customers} pelanggan dihapus',
  'orders.demoReset.last': 'Terakhir direset {time}',
}
